import Controller from '@ember/controller';
import AdminContactAddressChangeModel from 'donor-elf-web/models/admin/contact-address-change';

interface ChangedInfo {
  value: string;
  new: boolean;
  removed: boolean;
  same: boolean;
}

export default class AdminAddressChangesAddressChangeController extends Controller {
  model!: AdminContactAddressChangeModel;

  get phoneNumberChanges(): ChangedInfo[] {
    let oldPhones = new Set(this.model.oldPhones || []);
    let newPhones = new Set(this.model.newPhones || []);

    let phoneNumbers: ChangedInfo[] = [];
    for (let value of newPhones.difference(oldPhones)) {
      phoneNumbers.push({ value, new: true, removed: false, same: false });
    }
    for (let value of oldPhones.difference(newPhones)) {
      phoneNumbers.push({ value, new: false, removed: true, same: false });
    }
    for (let value of newPhones.intersection(oldPhones)) {
      phoneNumbers.push({ value, new: false, removed: false, same: true });
    }

    return phoneNumbers;
  }

  get emailChanges(): ChangedInfo[] {
    let oldEmails = new Set(this.model.oldEmails || []);
    let newEmails = new Set(this.model.newEmails || []);

    let emails: ChangedInfo[] = [];
    for (let value of newEmails.difference(oldEmails)) {
      emails.push({ value, new: true, removed: false, same: false });
    }
    for (let value of oldEmails.difference(newEmails)) {
      emails.push({ value, new: false, removed: true, same: false });
    }
    for (let value of newEmails.intersection(oldEmails)) {
      emails.push({ value, new: false, removed: false, same: true });
    }

    return emails;
  }
}
